<footer class="pt-2 pb-2">
  <a
    mat-button
    href="https://github.com/webvitalii/angular-expo"
    target="_blank"
    >Angular Expo on GitHub</a
  >
  <a
    mat-button
    href="http://web-profile.net/angular/"
    target="_blank"
    >Angular code samples</a
  >
</footer>
